import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';
import {SelectField} from '../fields';

export default function RelationFieldWidget<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    const isMultiple = props.config.multiple;

    return <SelectField
            {...props}
            valueResolver={(value, options) => {
                const result = [];
                if (isMultiple) {
                    const ids = value as (number | null | string)[] | null;

                    for (let i = 0; i < options.length; i++) {
                        const option = options[i];
                        if (option.value === null) {
                            if (ids && ids.includes(option.value)) {
                                return [option];
                            }

                            continue;
                        }

                        if (ids && ids.includes(+option.value)) {
                            result.push(option);
                        }
                    }

                    return result;
                }

                return options.find(option => {
                    if (value === null) {
                        return value === option.value;
                    }

                    return option.value !== null && value === +option.value;
                });
            }}
    />;
}
